export const findCityById = (countries, id) => {
  if (!countries) {
    return null;
  }

  let city = null;

  for (let country of countries) {
    for (let c of country.cities) {
      if (c.id === id) {
        city = c;
        break;
      }
    }

    if (city) {
      break;
    }
  }

  return city;
};



// WEBPACK FOOTER //
// ./src/utils/cities.js